import useOnCropAnnotationAddedOrSelected from "./useOnCropAnnotationAddedOrSelected";

export default useOnCropAnnotationAddedOrSelected;